function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "multi_svg__a",
  x: 34.636,
  y: 22.948,
  width: 31.248,
  height: 41.377,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3,
  result: "b"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#ff6c6c",
  floodOpacity: 0.686
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "b"
}), /*#__PURE__*/React.createElement("feComposite", {
  "in": "SourceGraphic"
})), /*#__PURE__*/React.createElement("style", null, ".multi_svg__d{fill:#383d5a;stroke:#1b1c26;stroke-width:2px}.multi_svg__k{fill:none}.multi_svg__j{stroke:none}"));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#383d5a",
  d: "M25.714 38.961h7.792v12.468h-7.792z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "multi_svg__d",
  d: "M23.376 49.87h12.468a4.675 4.675 0 014.675 4.675.779.779 0 01-.779.779H19.48a.779.779 0 01-.779-.779 4.675 4.675 0 014.675-4.675z"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  className: "multi_svg__d",
  transform: "translate(6.233 8.571)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "multi_svg__j",
  width: 46.753,
  height: 35.844,
  rx: 6
}), /*#__PURE__*/React.createElement("rect", {
  className: "multi_svg__k",
  x: 1,
  y: 1,
  width: 44.753,
  height: 33.844,
  rx: 5
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  fill: "#ff6c6c"
}, /*#__PURE__*/React.createElement("path", {
  className: "multi_svg__j",
  d: "M52.882 56.325h-5.244a5.008 5.008 0 01-5.002-5.002V35.95a5.008 5.008 0 015.002-5.002h5.244a5.008 5.008 0 015.002 5.002v15.373a5.008 5.008 0 01-5.002 5.002zm1.12-4.327l-7 .001h-.003 7.002z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M52.882 55.325a4.006 4.006 0 004.002-4.002V35.95a4.006 4.006 0 00-4.002-4.002h-5.244a4.006 4.006 0 00-4.002 4.002v15.373a4.006 4.006 0 004.002 4.002h5.244m-5.88-4.326h7a1 1 0 110 2h-7a1.002 1.002 0 01-1.005-1c0-.551.45-1 1.004-1m5.88 6.326h-5.243a6.01 6.01 0 01-6.002-6.002V35.95a6.01 6.01 0 016.002-6.002h5.244a6.01 6.01 0 016.002 6.002v15.373a6.01 6.01 0 01-6.002 6.002z",
  fill: "#1b1c26"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-.003 .001)",
  filter: "url(#multi_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M52.885 55.326h-5.244a4.006 4.006 0 01-4-4V35.953a4.006 4.006 0 014-4h5.244a4.006 4.006 0 014 4v15.373a4.006 4.006 0 01-4 4zm-5.881-4.325a1 1 0 100 2h7a1 1 0 100-2z",
  fill: "#ff6c6c"
}));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(1.999 26.493)",
  fill: "#ff6c6c",
  strokeWidth: 2,
  stroke: "#1b1c26"
}, /*#__PURE__*/React.createElement("rect", {
  className: "multi_svg__j",
  width: 21.818,
  height: 28.831,
  rx: 4
}), /*#__PURE__*/React.createElement("rect", {
  className: "multi_svg__k",
  x: 1,
  y: 1,
  width: 19.818,
  height: 26.831,
  rx: 3
}));

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M3.479 49.87h19.456M13 30.87",
  strokeLinecap: "round",
  fill: "none",
  stroke: "#1b1c26",
  strokeWidth: 2
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M48.889 34.97h2.991",
  stroke: "#7d3e44",
  strokeLinecap: "round",
  fill: "none",
  strokeWidth: 2
});

var SvgMulti = function SvgMulti(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65.884,
    height: 64.325
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

export default "data:image/svg+xml;base64,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";
export { SvgMulti as ReactComponent };